import { ActionConfigurationsQuery, ActionFileFragment } from 'generated/resources/graphql'

export enum ActionConfigurationIdentifiers {
  SendCustomEmail = 'processes_send_custom_email_action',
  SendSurvey = 'send_survey_action',
}

export const getIdentifierEnumFromString = (identifier?: string | null) => {
  return Object.values(ActionConfigurationIdentifiers).find((value) => value === identifier)
}

type ProcessesActionConfiguration = NonNullable<
  ActionConfigurationsQuery['processes']['actionConfigurationsConnection']['nodes'][number]
>

export interface ActionConfigurationElement extends ProcessesActionConfiguration {
  identifier: ActionConfigurationIdentifiers
}

export interface ActionItem {
  configurationIdentifier: ActionConfigurationIdentifiers
  configuration: object // TODO: Improve using BE types
  files: ActionFileFragment[]
}

export interface WizardActionElement {
  identifier: ActionConfigurationIdentifiers
  title: string
  includeAssignees: boolean
  includeFiles: boolean
}
